import { guideSteps } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="观影指南 · 快速上手"
          title="四步找到你想看的那一部"
          desc="不用注册、不用跳转多个页面，本页的筛选与标签切换就能帮你把候选影片缩小到几部之内。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {guideSteps.map((step, idx) => (
            <div
              key={step.id}
              className="relative p-5 rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <span className="absolute -right-3 -bottom-4 font-heading font-bold text-6xl text-background-200 select-none">
                0{idx + 1}
              </span>
              <span className="relative w-12 h-12 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
                <i className={`${step.icon} text-2xl`}></i>
              </span>
              <h3 className="relative mt-5 font-heading font-bold text-base md:text-lg text-foreground-950">
                {step.title}
              </h3>
              <p className="relative mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}